import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//import Cookies from 'universal-cookie';
import 'pace-js';
import 'pace-js/themes/yellow/pace-theme-minimal.css';

import { login, validarUsuario } from '../../redux/auth/actions';

const Login = ( props ) => {
    const dispatch = useDispatch();
    const id = localStorage.getItem("msal.idtoken");
    const salir = props.match.params.salir ? props.match.params.salir : '0';
    let guid = useSelector( (state) => state.auth.guid );
    let validated = useSelector( (state) => state.auth.guidValidated );   
    let firmarAppCrol = useSelector( (state) => state.auth.firmarAppCrol );  
    let crolGUID = (localStorage.getItem('crolSession') ? localStorage.getItem('crolSession') : null);

    if( guid && validated ) {
        if (firmarAppCrol === true){
            window.location.href = `${process.env.REACT_APP_BASEURLWEB}/home/LoginMicrosoft?GUID=${crolGUID}`;
        }
        else{
            window.location.href =`${process.env.REACT_APP_BASEURL}/webapp/home/LoginMicrosoft?GUID=${crolGUID}`;
        }
    }

    useEffect( () => {

        if( id ) {

            dispatch( validarUsuario( id, salir ) );
        }

        if( !id ) {
            dispatch( login() );
        }
        
        // eslint-disable-next-line
    }, [] );
    
    return (
        <div className="cargandoContent">
            <div className="cargandoItem">
                <img src={`${process.env.REACT_APP_BASEURLWEB}/img/cargandoCrol.gif`} alt="logoblanco" />
                <div className="sk-three-bounce">
                    <div className="sk-child sk-bounce1"></div>
                    <div className="sk-child sk-bounce2"></div>
                    <div className="sk-child sk-bounce3"></div>
                </div>
            </div>
        </div>
     );
}
 
export default Login;